import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[checkRole]'
})
export class RolePermissionDirective {
  @Input() checkRole: string;
  @Input() minRoleCheck: boolean = false;
  user: any;
  constructor(private authService: AuthService, private elementRef: ElementRef) { }
  ngOnInit() {

    this.user = this.authService.getLoggedUser()
    var found = true;
    var optionList = [];

    var elementRoles = this.checkRole.split(',')
    for (let i = 0; i < elementRoles.length; i++) {
      const r = elementRoles[i];
      optionList.push(r)
    }

    if (this.minRoleCheck) {
      found = false;

      for (let i = 0; i < optionList.length; i++) {
        const o = optionList[i];
        if (this.checkOptionInRole(o)) {
          return true;
        }
      }

    }
    else {

      for (let i = 0; i < optionList.length; i++) {
        const o = optionList[i];

        if (!this.checkOptionInRole(o)) {
          found = false;
          break;
        }

      }
    }

    if (!found) {
      this.elementRef.nativeElement.remove();
    }
  }


  checkOptionInRole(code) {
    if (this.user && this.user.RoleInfo) {

      for (let i = 0; i < this.user.RoleInfo.length; i++) {
        const role = this.user.RoleInfo[i];
        if (role == code) {
          return true;
        }
      }
    }
    return false;
  }


}



